// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"7db8b530260c0f971a0f","258":"6f38c26253bb201b9c9b"}[chunkId] + ".js";
};